module.exports = __webpack_public_path__ + "img/cv_profile_2.33407d66.jpg";